module.exports = __webpack_public_path__ + "img/letter-img1.7c7988be.png";